import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule],
  template: `<h1 style="text-align: center;">User Logged In </h1>`
})
export class CallbackComponent {
  constructor(private oauthService: OAuthService, private router:Router) {
   // this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
   //   window.location.href = '/';
   // });
  }
  ngOnInit(): void {
 
  }
  async init(){
     await this.oauthService.configure({
      issuer: 'https://risk-detection-router-papi.us-e1.cloudhub.io/ext/oauth2',
      redirectUri: 'http://10.87.0.16:4100/callback',
      clientId: 'demo_app',
      responseType: 'code',
      scope: 'openid profile',
      silentRefreshRedirectUri:'http://10.87.0.16:4100/callback',
      useSilentRefresh: true,
      silentRefreshTimeout: 5000,
      timeoutFactor: 0.75,
      sessionChecksEnabled: false,
      clearHashAfterLogin: true,
      skipIssuerCheck: true
      //oidc: true,
      //requestAccessToken: true
     //customQueryParams: {
       // 'acr_values': 'sparkmain',
        //'login_hint':'jamesmith@yopmail.com'
      //}
    }); 
    console.log("frist")
    this.oauthService.loadDiscoveryDocument().then(() => {
      console.log("second")

      this.oauthService.tryLogin().then(() => {
        console.log("third")

        if (this.oauthService.hasValidAccessToken()) {
          console.log('At callback');
          window.location.href = '/';
        } else {
          this.router.navigate(['/error']);
        }
      })
      .catch((err) => {
        console.log('Error during OAuth flow:', err);
      });
  })
  }
}